import Feature21 from './Feature21'
export default Feature21
